import { expectDefined } from '@utils';
import type { CanvasKit, FontMgr } from 'canvaskit';
import CanvasKitInit from 'canvaskit';

import { fontsData } from './fontsData';
import { pathJoiner } from './resourceUtils';

export let canvasKit: CanvasKit;
export let fontMgr: FontMgr;

export async function loadCanvasKit(
  prefix: string[],
  join?: typeof pathJoiner
): Promise<void> {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (canvasKit !== undefined) {
    return;
  }

  if (!join) {
    join = pathJoiner;
  }

  canvasKit = await CanvasKitInit({
    // Emscripten calls locateFile(path, scriptDir). We ignore scriptDir,
    // because our join() now returns an absolute URL rooted at BASE_URL.
    locateFile: (file: string, _scriptDir?: string) => join(prefix.concat(file))
  });
  const buffers = fontsData.map(fontData => fontData.buffer);
  fontMgr = expectDefined(canvasKit.FontMgr.FromData(...buffers));
}
